import { c as _c } from "react/compiler-runtime";
import { LexicalRichTextSection } from '@/features/payload-cms/components/content-blocks/lexical-rich-text-section';
import { type Locale, type StaticTranslationString } from '@/types/types';
import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import React from 'react';
const resetFormText: StaticTranslationString = {
  en: 'Reset Form',
  de: 'Formular zurücksetzen',
  fr: 'Réinitialiser le formulaire'
};
interface SubmissionMessageProperties {
  content?: SerializedEditorState;
  onReset: () => void;
  locale: Locale;
}
export const SubmissionMessage: React.FC<SubmissionMessageProperties> = t0 => {
  const $ = _c(9);
  const {
    content,
    onReset,
    locale
  } = t0;
  let t1;
  if ($[0] !== content || $[1] !== locale) {
    t1 = content && <LexicalRichTextSection richTextSection={content} locale={locale} />;
    $[0] = content;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = resetFormText[locale];
  let t3;
  if ($[3] !== onReset || $[4] !== t2) {
    t3 = <button type="button" onClick={onReset} className="bg-conveniat-green mt-4 h-10 w-full cursor-pointer rounded-lg px-4 font-['Montserrat'] text-base font-bold text-green-100 transition duration-300 hover:bg-green-600 sm:w-auto">{t2}</button>;
    $[3] = onReset;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div className="flex w-full flex-col items-center justify-center space-y-6 rounded-xl border border-gray-100 bg-white p-8 text-center shadow-sm"><div className="max-w-md">{t1}{t3}</div></div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};